import * as ActionTypes from "./actionTypes";

export function loadAppConfig(appKey) {
	return { type: ActionTypes.LOAD_APP_CONFIG, appKey };
}

export function loadAppConfigSuccess(appConfig, appName) {
	return { type: ActionTypes.LOAD_APP_CONFIG_SUCCESS, appConfig, appName };
}

export function loadAppConfigFailure(errorMessage) {
	return { type: ActionTypes.LOAD_APP_CONFIG_FAILURE, errorMessage };
}

export function saveAppConfig(appKey, values, submitCallback) {
	return { type: ActionTypes.SAVE_APP_CONFIG, appKey, values, submitCallback };
}

export function saveAppConfigSuccess(appConfig) {
	return { type: ActionTypes.SAVE_APP_CONFIG_SUCCESS, appConfig };
}

export function saveAppConfigFailure(errorMessage) {
	return { type: ActionTypes.SAVE_APP_CONFIG_FAILURE, errorMessage };
}

export function clearAppConfig() {
	return { type: ActionTypes.CLEAR_APP_CONFIG };
}
